/*
 * Copyright (c) 2024. Bolmate B.V.
 */

import React, {useContext, useEffect, useState} from 'react';
import {Navigate} from 'react-router';
import {AppContext} from "../misc/appContext";
import {LOGIN_ROUTE, REFER_A_FRIEND_ROUTE} from "../../util/constants";
import {referAFriend} from "../../util/requestSender";
import {ResponseData, showDialog, showSnackbar} from '@dvrd/dvr-controls';
import {createErrorMessage} from "../../util/utils";
import ReferAFriend from "./referAFriend";
import {onSetCrumbs} from "../../util/events";

export default function ReferAFriendController() {
    const {user} = useContext(AppContext).userContext;
    const [friendEmail, setFriendEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [createdAccountAccepted, setCreateAccountAccepted] = useState(false);
    const [paidSubAccepted, setPaidSubAccepted] = useState(false);
    const [firstPaymentAccepted, setFirstPaymentAccepted] = useState(false);
    if (!user) return <Navigate to={LOGIN_ROUTE}/>;

    function onChangeFriendEmail(value: string) {
        setFriendEmail(value);
    }

    function onChangeAccountCreatedAccepted() {
        setCreateAccountAccepted(!createdAccountAccepted);
    }

    function onChangePaidSubAccepted() {
        setPaidSubAccepted(!paidSubAccepted);
    }

    function onChangeFirstPaymentAccepted() {
        setFirstPaymentAccepted(!firstPaymentAccepted);
    }

    function onSubmit() {
        setLoading(true);
        referAFriend({
            data: {friend_email: friendEmail}, callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) {
                    reset();
                    showSnackbar('Bedankt! Het verzoek is ingediend, we nemen z.s.m. contact met je op.');
                } else
                    showDialog(createErrorMessage(data.message ?? 'Het indienden van het verzoek is niet gelukt.'),
                        'Indienen mislukt');
            }
        });
    }

    function reset() {
        setFriendEmail('');
        setPaidSubAccepted(false);
        setFirstPaymentAccepted(false);
    }

    useEffect(() => {
        onSetCrumbs([{label: 'Refer a friend', route: REFER_A_FRIEND_ROUTE}]);
    }, []);

    return (
        <ReferAFriend onChangeFriendEmail={onChangeFriendEmail} onChangePaidSubAccepted={onChangePaidSubAccepted}
                      onChangeFirstPaymentAccepted={onChangeFirstPaymentAccepted} onSubmit={onSubmit}
                      onChangeAccountCreatedAccepted={onChangeAccountCreatedAccepted}
                      friendEmail={friendEmail} paidSubAccepted={paidSubAccepted}
                      firstPaymentAccepted={firstPaymentAccepted} loading={loading} user={user}
                      createdAccountAccepted={createdAccountAccepted}/>
    );
}